export default {
  state: {
    darkSate: Boolean,
    selectedTheme: String,
    themesList: {
      Soft: {
        primary: '#00a8e8',
        secondary: '#052d52',
        accent: '#e91e63',
        error: '#ff9800',
        warning: '#ffeb3b',
        info: '#3f51b5',
        success: '#4caf50',
        //Main Pages
        centerPanel: '#0C0C10', //main background color on all pages
        SplitterBase: '#4B70B4', //thing you drag to resize panels
        SplitterHover: '#BDCAE3', //when you hover over the thing you drag to resize panels
        cardTitleBar: '#052d52', //component title bar background color
        cardBg: '#131820', //compoenent background color on trader profile
        dataTableBg: '#052d52', //client search, balances, onboarding, table background color
        bodyTextColor: '#daf6ff', //pretty much all text
        dividerColor: '#E2F1FF', //divider color between title and compoent on TP & Balances
        headerTextColor: '#D9DEF9', //component header text color on trader profile
        tpHeader: '#E2F1FF', //trader profile dialog main header text
        tpSubHeader: '#4A8FFF', //trader profile dialog sub header text
        //Order ticket stuff
        topBar: '#052d52', //call/put bar above option chain
        ocExpSlider: '#1f1f1f', //color behind option chain expiration dates
        otSysBar: '#0055a5', //system bar above the option chain order ticket
        otInnerCardBg: '#052d52', //equity and option order ticket card backgrounds
        otCardBg: '#052d52', //equity & option order ticket background color
      },
      Contrast: {
        primary: '#ff5717',
        accent: '#a1e754',
        secondary: '#92de4e',
        success: '#6dff74',
        info: '#7365ff',
        warning: '#2e8ac0',
        error: '#ff5e3c',
        cardTitleBar: '#556CA3',
        cardBg: '#343336',
        dataTableBg: '#343336',
        topBar: '#4b0082',
        headerTextColor: '#FFFFFF',
        bodyTextColor: '#FFFFFF',
        otSysBar: '#556CA3',
        otCardBg: '#2F2F2F',
        otInnerCardBg: '#3E4245',
        centerPanel: '#383838',
        ocExpSlider: '#2d005d',
      },
      Light: {
        primary: '#d5ebeb',
        accent: '#a1e754',
        secondary: '#052d52',
        success: '#6dff74',
        info: '#7365ff',
        warning: '#2e8ac0',
        error: '#ff5e3c',
        cardTitleBar: '#95bac2',
        cardBg: '#d5ebeb',
        dataTableBg: '#d5ebeb',
        topBar: '#2B7FC4',
        headerTextColor: '#000000',
        bodyTextColor: '#000000',
        dividerColor: '#000000',
        otSysBar: '#d5ebeb',
        otCardBg: '#d5ebeb',
        otInnerCardBg: '#d5ebeb',
        centerPanel: '#F4F9FC',
        selectColor: '#d5ebeb',
      },
    },
  },
  getters: {
    getDarkState: (state) => state.darkSate,
    getSelectedTheme: (state) => state.selectedTheme,
    getThemeSoft: (state) => state.themesList['Soft'],
    getThemeContrast: (state) => state.themesList['Contrast'],
    getThemeLight: (state) => state.themesList['Light'],
  },
  mutations: {
    setSelectedTheme: (state, selectedTheme) => {
      state.selectedTheme = selectedTheme
    },
    setDarkState: (state, darkSate) => {
      state.darkSate = darkSate
    },
  },
}
